import React, { useReducer } from 'react';
import { Employee } from '@Models/Employee';

type State = {
    employees: Employee[],
};

export type EmployeeManagerAction = {
    type: string;
    employee?: Employee
}
export enum EmployeeManagerActionType {
    EmployeeAdded = "USER_ADDED",
    EmployeeDeleted = "USER_DELETED",
    EmployeeEdited = "USER_EDITED",
}

const emptyState: State = {
    employees: []
}

type ContextType = State & {
    dispatch: React.Dispatch<EmployeeManagerAction>
};

export const EmployeeManagerContext = React.createContext<ContextType>({
    ...emptyState,
    dispatch: () => { }
});

function reducer(state: State, action: EmployeeManagerAction): State {
    switch (action.type) {
        case EmployeeManagerActionType.EmployeeAdded:
            return {
                employees: [...state.employees, action.employee]
            };
        case EmployeeManagerActionType.EmployeeDeleted: {
            const index = state.employees.findIndex(x => x.email === action.employee.email);
            if (index < 0) throw new Error('Could not find user to delete in context');
            const userUsers = [...state.employees];
            userUsers.splice(index, 1);
            return { employees: userUsers };
        }
        case EmployeeManagerActionType.EmployeeEdited: {
            const index = state.employees.findIndex(x => x.email === action.employee.email);
            if (index < 0) throw new Error('Could not find user to edit in context');
            const userUsers = [...state.employees];
            userUsers[index] = action.employee;
            return { employees: userUsers };
        }
        default:
            return state;
    }
}

export function EmployeeManagerContextProvider(props: { children: JSX.Element[] | JSX.Element, initialState?: State }) {
    const [state, dispatch] = useReducer(reducer, props.initialState || emptyState);
    const value = { ...state, dispatch };
    return <EmployeeManagerContext.Provider value={value}>{props.children}</EmployeeManagerContext.Provider>;
}
